export default __webpack_public_path__ + "static/media/user (6).51543718.png";